<template>
    <a-result
        status="success"
        :title="$t('user.security.tfa.step_4.title')"
        :sub-title="$t('user.security.tfa.step_4.sub_title')"
    >
        <template #extra>
            <a-button type="primary" @click="cancelTFA" data-cy="tfa-go-back-button">
                {{ $t('user.security.tfa.go_back') }}
            </a-button>
        </template>
    </a-result>
</template>

<script>
export default {
    methods: {
        cancelTFA() {
            this.$emit('cancelTFA');
        },
    },
};
</script>
